import { useAccountStore } from '@/stores/account';
import { authService } from '../services/auth.service';
import type { ApiResult } from '@/core/either';
import type { KycCompliance } from '@/types/KycCompliance';

export function useKyc() {
  const accountStore = useAccountStore();

  /**
   * Actualiza el estado KYC desde la API.
   * Gestiona automáticamente localStorage y store en caso de éxito.
   * @returns Promise<ApiResult<KycCompliance>> - Either con el resultado
   */
  const updateKycStatus = async (): Promise<ApiResult<KycCompliance>> => {
    const result = await authService.getKycStatus();

    if (result.isRight()) {
      const data = JSON.stringify(result.value.data);
      localStorage.setItem('g-kyc-status', data);
      accountStore.setKyc(result.value.data);
    }

    return result;
  };

  return {
    updateKycStatus,
  };
}
